import { StarIcon } from '@heroicons/react/solid';
import { classNames } from 'lib/utils';
import ReviewPhoto1 from '@/images/reviews/energypal-5-star-review-mike-l.png';
import ReviewPhoto2 from '@/images/reviews/energypal-5-star-review-christopher-grijalva.png';
import ReviewPhoto3 from '@/images/reviews/energypal-5-star-review-henna-m.png';
import Image from 'next/legacy/image';
import { StaticImageData } from 'next/image';

const reviews = [
  {
    name: 'Mike L.',
    rating: 5,
    photo: ReviewPhoto1,
    comment: `They walked me through the steps to build out my solar configuration, and define my requirements while trying to get some "nice-to-haves" as well. They then went on to compare companies in my area's warranties, the panels, and a whole lot of other information without pressuring me to choose a specific company. I was completely in control of my choices. After a site survey, it turned out that my initial solar configuration wouldn't work due to roof layout, but they were able to run different configurations of panels to meet my requirements. All in all, I would recommend EnergyPal to friends and family for their service!`,
  },
  {
    name: 'Christopher Grijalva',
    rating: 5,
    photo: ReviewPhoto2,
    comment: `My EnergyPal advisor was very helpful and knowledgeable. he took the time to go over all the aspects of the potential project and explained what would happen and why things were being done. it was helpful to not only see the numbers for the project but he also explained the warranty, financing, tax incentives, and how the project would be installed. Overall I felt he provided good information so that I can make an informed decision.`,
  },
  {
    name: 'Henna M.',
    rating: 5,
    photo: ReviewPhoto3,
    comment: `This was probably the best "Solar" experience I had and I've been shopping around for solar panels for more than two years now. My consultant was awesome! He's honest, friendly, communicative, very easy to talk to, extremely attentive and patient, and willing to answer any questions you may have. I really appreciated his candor about every detail discussed. Felt like I knew exactly what I was signing up for at each step of the way not to mention he ended up giving me the most competitive rate which I could not pass. I'm glad I signed up with them and feel confident that this is indeed the one company with the most competitive package. I have already referred them to a few people and have a feeling there will be more!`,
  },
];

type ReviewBlockProps = {
  review: {
    name: string;
    rating: number;
    photo: StaticImageData;
    comment: string;
  };
};

function ReviewBlock({
  review: { name, comment, photo, rating },
}: ReviewBlockProps) {
  return (
    <div className="flex flex-col overflow-hidden rounded-lg shadow-lg">
      <div className="flex flex-col justify-between flex-1 p-6 bg-white">
        <div className="flex items-center mb-3">
          <div className="flex-shrink-0">
            <span className="sr-only">{name}</span>
            <Image className="w-10 h-10 rounded-full" src={photo} alt={name} />
            {/* <img className="w-10 h-10 rounded-full" src={photo} alt={name} /> */}
          </div>
          <div className="ml-3">
            <p className="pl-1 text-sm font-medium text-gray-900">{name}</p>
            <div className="flex items-center">
              {[0, 1, 2, 3, 4].map((count) => (
                <StarIcon
                  key={count}
                  className={classNames(
                    rating > count ? 'text-yellow-400' : 'text-gray-300',
                    'h-5 w-5 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
              ))}
            </div>
          </div>
        </div>
        <div className="flex-1">
          <p className="text-base text-gray-500">{comment}</p>
        </div>
      </div>
    </div>
  );
}

export default function WhatOurCustomersAreSaying() {
  return (
    <div className="pt-16 pb-16 mb-4 bg-primary">
      <div className="max-w-xl px-4 mx-auto sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="mt-2 text-3xl font-bold tracking-tight text-center text-white sm:text-4xl">
          What Our Customers Are Saying
        </h2>
        <div className="flex items-center justify-center py-2">
          <h2 className="text-white">4.9 </h2>
          {[0, 1, 2, 3, 4].map((count) => (
            <StarIcon
              key={count}
              className="text-yellow-400 h-5 w-5 flex-shrink-0"
              aria-hidden="true"
            />
          ))}
          <h2 className="text-white"> 900+ Google Reviews</h2>
        </div>

        <div className="grid max-w-lg gap-5 mx-auto mt-12 lg:max-w-none lg:grid-cols-3">
          {reviews.map((review) => (
            <ReviewBlock key={review.name} review={review} />
          ))}
        </div>
      </div>
    </div>
  );
}
